// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordPropertyCreateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreatePropertyWebRequestDto, CreatePropertyWebResponseDto } from '../..';

export const CappsLandlordPropertyCreateWebApiHandler_create_Path = '/api/web/landlord/v1/properties/create';

export const CappsLandlordPropertyCreateWebApiHandler_create = (
  postData: CreatePropertyWebRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreatePropertyWebRequestDto, CreatePropertyWebResponseDto>(
    {
      endpoint: CappsLandlordPropertyCreateWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
